import React, { useEffect, useState, /*useReducer,*/ useContext } from "react";
import {
  makeStyles,
  Grid,
  Typography,
  MenuItem,
  Collapse,
  RootRef,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";
//import { useHistory } from 'react-router-dom'
//import randomMC from 'random-material-color'
import { AuthContext } from "../context";
import {
  TextField,
  /*ProductCard, LabCard ,*/ Paper,
  PopUp,
  Button,
  Loader,
} from "../components";
import { doctorServices } from "../services";
import { EditIcon, AddIcon } from "../icons";
import { formatDate, FormValidator, normalizeRutForApi } from "../helpers";
import { modals } from "../constants";
import { useScroll, useResize } from "../hooks";

const validator = new FormValidator([
  {
    field: "name",
    method: "isEmpty",
    validWhen: false,
    message: "Ingrese su nombre.",
  },
  {
    field: "lastName",
    method: "isEmpty",
    validWhen: false,
    message: "Ingrese sus apellidos.",
  },
  {
    field: "email",
    method: "isEmpty",
    validWhen: false,
    message: "Ingrese correo electronico.",
  },
  {
    field: "email",
    method: "isEmail",
    validWhen: true,
    message: "Correo electronico invalido.",
  },
  {
    field: "phone",
    method: "isEmpty",
    validWhen: false,
    message: "Ingrese su numero de telefono.",
  },
  {
    field: "birthDate",
    method: "isEmpty",
    validWhen: false,
    message: "Ingrese su fecha de nacimiento.",
  },
]);

export default function ProfileScreen(props) {
  const { domRef, paperGrow, onScroll } = useScroll();
  const [imageLoaded, setImageLoaded] = useState(false);
  const { collapseH } = useResize(imageLoaded);
  const classes = useStyles({ paperGrow, collapseH, ...props })();
  const [loading, setLoading] = useState(false);
  const { authState } = useContext(AuthContext);
  let {
    user: {
      doctor: {
        rut,
        name: doctorName,
        lastName: doctorLastName,
        email: doctorEmail,
        phone: doctorPhone,
        birthdate: doctorBirthdate,
        gender: doctorGender,
        specialties: doctorSpecialties,
      },
    },
  } = authState;

  const [index, setIndex] = useState(null);
  const [name, setName] = useState(doctorName.toUpperCase());
  const [lastName, setLastName] = useState(doctorLastName.toUpperCase());
  const [email, setEmail] = useState(doctorEmail.toUpperCase());
  const [phone, setPhone] = useState(doctorPhone.toUpperCase());
  // if (doctorBirthdate.toString().length === 4) {
  //   doctorBirthdate = `00-00-${doctorBirthdate}`;
  // }
  // const dateAux = doctorBirthdate.split("-");
  const [birthDate, setBirthDate] = useState(doctorBirthdate);
  const [gender, setGender] = useState(doctorGender.toUpperCase());
  const [specialtiesList, setSpecialtiesList] = useState([]);
  const [modalName, setModalName] = useState("");
  const [modal, setModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [specialties, setSpecialties] = useState([...doctorSpecialties]);
  const [errors, setErrors] = useState({});
  const [userToUpdate, setUserToUpdate] = useState(null);
  const [modalSubMessage, setModalSubMessage] = useState("");
  const [modalError, setModalError] = useState(false);
  const matchesDesktop = useMediaQuery(useTheme().breakpoints.up("md"));

  useEffect(() => {
    async function init() {
      try {
        const { status, response } = await doctorServices.getSpecialties();
        if (status === 200) {
          setSpecialtiesList(response.specialties);
        }
      } catch (e) {}
    }
    init();
  }, []);

  const onChangeSpecialties = (e, Index) => {
    const aux = [...specialties];
    aux[Index] = specialtiesList.find((specialty) => specialty._id === e);
    setSpecialties(aux);
  };

  const onSubmit = async () => {
    const validation = validator.validate({
      name,
      lastName,
      email,
      phone,
      birthDate: birthDate ? birthDate : "",
    });
    setErrors(validation);
    if (validation.isValid) {
      let aux = birthDate.split("/");
      try {
        setLoading(true);
        const { status, response } = await doctorServices.editDoctorProfile({
          _id: authState.user._id,
          token: authState.token,
          user: {
            email,
            doctor: {
              rut: authState.user.doctor.rut,
              gender,
              name,
              lastName,
              birthdate: birthDate,
              phone,
              specialties,
            },
          },
        });
        setLoading(false);
        if (status === 200) {
          setModalName(modals[2]);
          //console.log(response.message)
          setModalMessage(response.message);
          setModalSubMessage("Perfil editado con éxito");
          setModal(true);
          setUserToUpdate({
            user: {
              ...authState.user,
              email,
              doctor: {
                ...authState.user.doctor,
                gender,
                name,
                lastName,
                birthdate: `${aux[2]}-${aux[1]}-${aux[0]}`,
                phone,
                specialties,
              },
            },
          });
        } else {
          console.log("Error", { response });
        }
      } catch (e) {}
      setIndex(null);
    }
  };

  const onClickChangePassword = async ({ token, password }) => {
    setModal(false);
    try {
      setLoading(true);
      const { status, response } = await doctorServices.updatePassword({
        token,
        password,
      });
      setLoading(false);
      //console.log({status, response});
      if (status === 200) {
        if (response.error) {
          setModalError(true);
          setModalMessage(response.error.message);
        } else {
          setModalError(false);
          setModalMessage(response.message);
          setModalSubMessage("Contraseña actualizada con éxito.");
        }
        setModalName(modals[2]);
      }
      setModal(true);
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const sendToken = async () => {
    try {
      setLoading(true);
      const { status } = await doctorServices.sendTokenResetPassword({
        rut: normalizeRutForApi(rut),
      });
      setLoading(false);
      if (status === 200) {
        setModalError(false);
        setModalName(modals[7]);
      } else {
        setModalError(true);
        setModalMessage(
          "No pudimos enviar las instrucciones. Intenta nuevamente más tarde o verifica el RUT."
        );
        setModalName(modals[2]);
      }
      setModal(true);
    } catch (e) {
      setLoading(false);
      setModalError(true);
      setModalMessage(
        "No pudimos enviar las instrucciones. Intenta nuevamente más tarde o verifica el RUT."
      );
      setModalName(modals[2]);
      setModal(true);
      console.log(e);
    }
  };

  let sw_status = navigator?.serviceWorker?.controller
    ? navigator?.serviceWorker?.controller?.state
    : "No Disponible";

  return (
    <Grid container>
      <PopUp
        modalName={modalName}
        open={modal}
        setModal={() => setModal(!modal)}
        message={modalMessage}
        modalStep={1}
        modalError={modalError}
        modalSubMessage={modalSubMessage}
        onClickChangePassword={({ token, password }) =>
          onClickChangePassword({ token, password })
        }
        userToUpdate={userToUpdate}
      />
      {loading && <Loader loading={true} />}
      <Grid className={classes.container} container>
        <Collapse
          in={!matchesDesktop ? !paperGrow : true}
          timeout={1000}
          id={"collapseId"}
        >
          <Grid className={classes.containerImage} container>
            <Grid item md={3} xs={6}>
              <img
                src="../../assets/perfil.svg"
                alt=""
                onLoad={() => setImageLoaded(true)}
              />
            </Grid>
            <Grid
              md={9}
              className={classes.desktopOptions}
              container
              justify="flex-start"
              alignItems="center"
              item
            >
              <Grid item md={12} lg={12}>
                <Typography component="h1" variant="h1">
                  Perfil
                </Typography>
              </Grid>
              <Grid item md={8} xs={5}>
                <Typography>Rut</Typography>
                <Typography>
                  {rut.charAt(rut.length - 2) === "-"
                    ? rut
                    : `${rut.slice(0, rut.length - 1)}-${rut.slice(
                        rut.length - 1
                      )}`}
                </Typography>
              </Grid>
              <Grid
                item
                md={4}
                xs={7}
                container
                justify="center"
                alignItems="center"
              >
                <Button
                  fullWidth
                  className={classes.passwordButton}
                  onClick={sendToken}
                >
                  Editar Contraseña <EditIcon color="#FFF" />
                </Button>
                {index && (
                  <Button
                    style={{ margin: "8px 0 0" }}
                    onClick={onSubmit}
                    fullWidth
                    className={classes.btn}
                  >
                    Guardar cambios
                  </Button>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Collapse>
        <Paper className={classes.paperClass}>
          <Grid container className={classes.containerIn}>
            <Grid container className={classes.titleProfile}>
              <Grid item sm={6} xs={5} style={{ marginBottom: 20 }}>
                <Typography>Rut</Typography>
                <Typography>
                  {rut.charAt(rut.length - 2) === "-"
                    ? rut
                    : `${rut.slice(0, rut.length - 1)}-${rut.slice(
                        rut.length - 1
                      )}`}
                </Typography>
              </Grid>
              <Grid
                item
                sm={6}
                xs={7}
                container
                justify="center"
                alignItems="center"
              >
                <Button
                  fullWidth
                  className={classes.passwordButton}
                  onClick={sendToken}
                >
                  Contraseña <EditIcon color="#FFF" />
                </Button>
                <br />
                {index && (
                  <Button
                    style={{ margin: "8px 0 0" }}
                    onClick={onSubmit}
                    fullWidth
                    className={classes.btn}
                  >
                    Guardar cambios
                  </Button>
                )}
              </Grid>
            </Grid>
            <RootRef rootRef={domRef}>
              <Grid
                container
                spacing={2}
                className={classes.scrollList}
                onScroll={onScroll}
              >
                <Grid item xs={12} md={6}>
                  <Typography className={classes.titles}>Nombre</Typography>
                  <TextField
                    profile={index !== 1}
                    iconComponent={() => <EditIcon />}
                    style={{ justifyContent: "flex-end" }}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    onClickIcon={() => setIndex(1)}
                    disabled={index !== 1}
                    error={errors.name && errors.name.isInvalid}
                    helperText={errors.name ? errors.name.message : ""}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography className={classes.titles}>Apellidos</Typography>
                  <TextField
                    iconComponent={() => <EditIcon />}
                    style={{ justifyContent: "flex-end" }}
                    value={lastName}
                    profile={index !== 2}
                    onChange={(e) => setLastName(e.target.value)}
                    onClickIcon={() => setIndex(2)}
                    disabled={index !== 2}
                    error={errors.lastName && errors.lastName.isInvalid}
                    helperText={errors.lastName ? errors.lastName.message : ""}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography className={classes.titles}>Email</Typography>
                  <TextField
                    iconComponent={() => <EditIcon />}
                    style={{ justifyContent: "flex-end" }}
                    value={email}
                    profile={index !== 3}
                    onChange={(e) => setEmail(e.target.value)}
                    onClickIcon={() => setIndex(3)}
                    disabled={index !== 3}
                    error={errors.email && errors.email.isInvalid}
                    helperText={errors.email ? errors.email.message : ""}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography className={classes.titles}>Telefono</Typography>
                  <TextField
                    iconComponent={() => <EditIcon />}
                    style={{ justifyContent: "flex-end" }}
                    value={phone}
                    profile={index !== 4}
                    onChange={(e) => setPhone(e.target.value)}
                    onClickIcon={() => setIndex(4)}
                    disabled={index !== 4}
                    error={errors.phone && errors.phone.isInvalid}
                    helperText={errors.phone ? errors.phone.message : ""}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography className={classes.titles}>Sexo</Typography>
                  <TextField
                    iconComponent={() => (index !== 5 ? <EditIcon /> : null)}
                    style={{ justifyContent: "flex-end" }}
                    value={gender}
                    select={index === 5}
                    profile={index !== 5}
                    onChange={(e) => setGender(e.target.value)}
                    onClickIcon={() => setIndex(5)}
                    disabled={index !== 5}
                  >
                    <MenuItem value={"N"} disabled={true}>
                      Sexo
                    </MenuItem>
                    <MenuItem value={"MASCULINO"}>Masculino</MenuItem>
                    <MenuItem value={"FEMENINO"}>Femenino</MenuItem>
                    <MenuItem value={"OTRO"}>Otro</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography className={classes.titles}>
                    Año de nacimiento
                  </Typography>
                  <TextField
                    iconComponent={() => (index !== 6 ? <EditIcon /> : null)}
                    style={{ justifyContent: "flex-end" }}
                    type={"number"}
                    value={birthDate}
                    profile={index !== 6}
                    fromProfile={index === 6}
                    onChange={(ev) => {
                      if (ev.target.value.length < 5) {
                        setBirthDate(ev.target.value);
                      }
                    }}
                    onClickIcon={() => setIndex(6)}
                    disabled={index !== 6}
                    error={errors.birthDate && errors.birthDate.isInvalid}
                    helperText={
                      errors.birthDate ? errors.birthDate.message : ""
                    }
                  />
                </Grid>
                {specialties.map((element, Index) => (
                  <Grid item xs={12} md={6} key={element._id}>
                    <Typography className={classes.titles}>
                      {Index === 0
                        ? "Especialidad"
                        : `Sub-Especialidad ${Index}`}
                    </Typography>
                    <TextField
                      iconComponent={() =>
                        index !== 9 + Index ? <EditIcon /> : null
                      }
                      select={index === 9 + Index}
                      disabled={index !== 9 + Index}
                      profile={index !== 9 + Index}
                      name={element.name}
                      style={{ justifyContent: "flex-end" }}
                      value={index === 9 + Index ? element._id : element.name}
                      onChange={(e) =>
                        onChangeSpecialties(e.target.value, Index)
                      }
                      onClickIcon={() => setIndex(9 + Index)}
                      placeholder="Especialidad *"
                    >
                      <MenuItem value={"N"} disabled={true}>
                        Especialidad
                      </MenuItem>
                      {specialtiesList.map((element, index) => (
                        <MenuItem key={index} value={element._id}>
                          {element.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                ))}
                <Grid item xs={12} md={6}>
                  <Typography className={classes.titles}>
                    APP Estatus
                  </Typography>
                  <TextField
                    style={{ justifyContent: "flex-end" }}
                    value={sw_status}
                    profile={true}
                    disabled={true}
                  />
                </Grid>
                <Grid
                  container
                  justify="space-between"
                  item
                  xs={12}
                  sm={12}
                  className={classes.containerMiniButton}
                  alignItems="center"
                >
                  <div></div>
                  <Button
                    onClick={() => {
                      const aux = [...specialties];
                      aux.push({});
                      setSpecialties(aux);
                    }}
                  >
                    {" "}
                    <AddIcon color={"#2196C0"} /> AGREGAR <br />{" "}
                    SUB-ESPECIALIDAD
                  </Button>
                  <div></div>
                </Grid>
              </Grid>
            </RootRef>
          </Grid>
          {/* {index && (
            <Grid className={classes.containerBtn}>
              <Button onClick={onSubmit} fullWidth className={classes.btn}>
                Guardar cambios
              </Button>
            </Grid>
          )} */}
        </Paper>
      </Grid>
    </Grid>
  );
}

const useStyles = ({ buttonActive, paperGrow, collapseH, ...props }) =>
  makeStyles((theme) => ({
    container: {
      display: "block",
      height: "100%",
      [theme.breakpoints.up("md")]: {
        padding: "50px 50px 0 50px",
      },
    },
    containerIn: {
      height: "100%",
      "& > div:nth-child(1)": {
        padding: "17px 13px 0px 13px",
        "& p:nth-child(1)": {
          color: theme.palette.secondary.main,
          fontSize: "0.813rem",
          lineHeight: "1rem",
          fontWeight: "500",
        },
        "& p:nth-child(2)": {
          color: theme.palette.primary.main,
          fontSize: "1.125rem",
          lineHeight: "1.375rem",
          fontWeight: "500",
          margin: "10px 0 0 0",
        },
      },
      "& > div:nth-child(2)": {
        "& button": {
          fontSize: "0.875rem",
          lineHeight: "1rem",
          justifyContent: "space-around",
        },
      },
    },
    containerBtn: {
      position: "fixed",
      bottom: "calc(90px + env(safe-area-inset-bottom, 0px))",
      padding: "0 12px",
      zIndex: 3,
    },
    btn: {
      maxWidth: "80vw",
      margin: "0 auto",
    },
    titles: {
      padding: "0 13px",
      fontSize: "0.813rem",
      fontWeight: "500",
      lineHeight: "1rem",
      color: theme.palette.secondary.main,
      margin: "0 0 10px 0",
    },
    containerImage: {
      justifyContent: "center",
      [theme.breakpoints.up("md")]: {
        justifyContent: "flex-start",
      },
      "& > div:nth-child(1)": {
        padding: "10px 0",
        [theme.breakpoints.up("md")]: {
          padding: 0,
        },
        "& img": {
          [theme.breakpoints.up("md")]: {
            width: "100%",
          },
        },
      },
      "& > div:nth-child(2)": {
        [theme.breakpoints.up("md")]: {
          padding: "0 0 0 40px",
        },
      },
    },
    desktopOptions: {
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
      "& > div:nth-child(2)": {
        "& > p:nth-child(1)": {
          color: theme.palette.secondary.main,
          fontSize: "0.813rem",
          lineHeight: "1rem",
          fontWeight: "500",
        },
        "& > p:nth-child(2)": {
          color: theme.palette.primary.main,
          fontSize: "1.125rem",
          lineHeight: "1.375rem",
          fontWeight: "500",
          margin: "10px 0 0 0",
        },
      },
    },
    titleProfile: {
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
    },
    titleHistoryDesktop: {
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
    containerMiniButton: {
      margin: "30px 0 30px 0",
      "& > div:nth-child(1), > div:nth-child(3)": {
        width: "15%",
        height: 2,
        borderTop: "1pt solid #CCCCCC",
        [theme.breakpoints.up("md")]: {
          width: "40%",
        },
      },
      "& button": {
        padding: "5px 15px",
        boxSizing: "content-box",
        fontSize: "0.625rem",
        lineHeight: "0.75rem",
        width: "60%",
        [theme.breakpoints.up("md")]: {
          width: "20%",
          boxSizing: "border-box",
        },
        display: "flex",
        color: theme.palette.secondary.main,
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "#FFFFFF",
        boxShadow: "0px 4px 10px rgba(198, 198, 198, 0.5)",
        borderRadius: 12.5,
        "&:hover": {
          backgroundColor: "#FFFFFF",
        },
      },
    },
    paperClass: {
      height: paperGrow ? "100%" : "calc(100% - 159px)",
      [theme.breakpoints.up("md")]: {
        height: `calc(100% - ${collapseH}px)`,
      },
    },
    scrollList: {
      overflowY: "scroll",
      [theme.breakpoints.up("md")]: {
        display: "flex",
        height: "98%",
      },
      [theme.breakpoints.down("sm")]: {
        "&::-webkit-scrollbar": {
          width: "1px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "rgba(0,0,0, .1)",
        },
      },
      display: "block",
      paddingTop: 0,
      width: "100%",
      margin: 0,
      height: "calc(100% - 85px)",
      "&::-webkit-scrollbar": {
        width: "4px",
        height: "8px",
      },
      "&::-webkit-scrollbar-track": {
        boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
        webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: theme.palette.secondary.main,
        borderRadius: "10px",
      },
    },
    passwordButton: {
      justifyContent: "space-around",
    },
  }));
